export enum CONFIRMATION_TYPES {
  DELETE = "delete",
  CANCEL = "cancel",
  RESET = "reset",
  ENABLE = "enable",
  DISABLE = "disable",
  SUBMIT = "submit",
}
